<template>
  <!-- <b-field v-if="isButton">
      <b-select expanded v-model="buffer" @input="$emit('input', buffer)">
        <option :value="null">{{ $t('compCarbonFormsUpload.overview') }}</option>
        <option v-for="(source, key) in sources" :key="key" :value="source">
          {{ $t('compCarbonFormsUpload.label-1') }} {{ source }}
        </option>
      </b-select>
      <p class="control">
        <b-tooltip
          :label="$t('compCarbonFormsUpload.tooltip-1')"
          type="is-black"
          position="is-top"
        >
          <b-button
            :disabled="submitted || nitems === 0"
            @click="del"
            icon-left="trash"
          />
        </b-tooltip>
      </p>
      <p class="control">
        <b-upload v-model="dropFile">
          <b-tooltip
            :label="$t('upload')"
            type="is-black"
            position="is-top"
          >
            <a class="button">
              <b-icon icon="upload"></b-icon>
            </a>
          </b-tooltip>
        </b-upload>
      </p>
    </b-field> -->
  <div class="columns">
    <div class="column">
      <b-notification :closable="false">
        <b-field>
          <b-select expanded v-model="buffer" @input="$emit('input', buffer)">
            <option :value="null">
              {{ $t('compCarbonFormsUpload.overview') }}
            </option>
            <option v-for="(source, key) in sources" :key="key" :value="source">
              {{ $t('compCarbonFormsUpload.label-1') }} {{ source }}
            </option>
          </b-select>
          <p class="control">
            <b-tooltip
              v-if="download"
              :label="$t('compCarbonFormsUpload.tooltip-2')"
              type="is-black"
              position="is-top"
            >
              <b-button
                :disabled="disabled || nitems === 0"
                @click="download"
                icon-left="download"
              />
            </b-tooltip>
            <b-tooltip
              :label="$t('compCarbonFormsUpload.tooltip-1')"
              type="is-black"
              position="is-top"
            >
              <b-button
                :disabled="disabled || nitems === 0"
                @click="del"
                icon-left="trash"
              />
            </b-tooltip>
          </p>
        </b-field>
      </b-notification>
      <div class="columns" v-if="useInfo">
        <div v-for="(info, key) in infos" :key="key" class="column">
          <b-notification :closable="false">
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">
                  {{ info.label }}
                  <b-tooltip
                    v-if="'tooltip' in info"
                    :label="info.tooltip"
                    position="is-bottom"
                    multilined
                    type="is-dark"
                  >
                    <b-icon icon="info-circle" />
                  </b-tooltip>
                </p>
                <div class="title is-size-4">
                  <p v-html="info.value" />
                </div>
              </div>
            </div>
          </b-notification>
        </div>
      </div>
    </div>
    <div class="column is-one-third is-vcentered">
      <b-upload
        :disabled="disabled"
        v-model="dropFile"
        drag-drop
        expanded
        type="is-info"
        :data-testid="`upload-${module}`"
      >
        <section class="section">
          <div class="content has-text-centered">
            <p>
              <span class="icon">
                <i style="font-size: 36px" class="fa fa-upload"></i>
              </span>
            </p>
            <p>{{ $t('compCarbonFormsUpload.label-3') }}</p>
          </div>
        </section>
      </b-upload>
    </div>
    <!-- Error managment -->
    <upload-errors
      :active="displayErrors"
      :error="error"
      :module="module"
      @close="displayErrors = false"
    >
    </upload-errors>
  </div>
</template>

<script>
import { useGHGIStore } from '@/stores/ghgi.js'
import { parseFile } from '@/utils/parser.js'

const MAX_FILE_SIZE = 1024 * 512 // 500 ko

export default {
  name: 'Upload',
  props: {
    module: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    formatDescription: {
      type: [Object, Function],
      required: true
    },
    callback: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    download: {
      type: Function,
      default: null
    },
    infos: {
      type: Array,
      default: function () {
        return []
      }
    },
    useInfo: {
      type: Boolean,
      default: true
    },
    isButton: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'upload-errors': () => import('@/components/carbon/forms/UploadErrors.vue')
  },
  setup () {
    const ghgiStore = useGHGIStore()
    return { ghgiStore }
  },
  data () {
    return {
      dropFile: null,
      error: null,
      displayErrors: false,
      buffer: this.value
    }
  },
  computed: {
    nitems: function () {
      return this.ghgiStore.items(this.module).length
    },
    sources: function () {
      return Array.from(
        new Set(
          this.ghgiStore
            .items(this.module)
            .filter((obj) => obj.source !== null)
            .map((obj) => obj.source)
        )
      )
    }
  },
  methods: {
    del: function () {
      let self = this
      let msg =
        this.$t('compCarbonFormsUpload.delete-msg-file') +
        ' <strong>' +
        this.value +
        '</strong> ?'
      let source = this.value
      if (this.value === null) {
        msg = this.$t('compCarbonFormsUpload.delete-msg-all')
        source = null
      }
      this.$buefy.dialog.confirm({
        title: self.$t('compCarbonFormsUpload.delete-msg-title'),
        message: msg,
        confirmText: self.$t('validate'),
        cancelText: self.$t('cancel'),
        canCancel: ['escape', 'button', 'outside'],
        onConfirm: function () {
          self.ghgiStore.deleteSource({
            module: self.module,
            source: source
          })
          self.$emit('update')
          self.buffer = null
          self.$emit('input', self.buffer)
          self.dropFile = null
        }
      })
    },
    processFile () {
      if (!this.sources.includes(this.dropFile.name)) {
        this.$emit('update')
        parseFile(this.dropFile, this.formatDescription, this.callback)
          .then((results) => {
            // display all data
            this.buffer = null
            this.$emit('input', this.buffer)
          })
          .catch((error) => {
            this.error = error
            this.displayErrors = true
          })
      } else {
        this.$buefy.dialog.alert({
          title: this.$t('compCarbonFormsUpload.error-msg-title'),
          message: this.$t('compCarbonFormsUpload.error-msg-duplicate')
        })
      }
    }
  },
  watch: {
    dropFile: function () {
      this.error = null
      if (this.dropFile) {
        // if file size > MAX_FILE_SIZE warn user for processing time
        let self = this
        if (this.dropFile.size > MAX_FILE_SIZE) {
          this.$buefy.dialog.confirm({
            title: self.$t('compCarbonFormsUpload.file-size.title'),
            message: self.$t('compCarbonFormsUpload.file-size.msg'),
            confirmText: self.$t('validate'),
            cancelText: self.$t('cancel'),
            onConfirm: () => self.processFile()
          })
        } else {
          this.processFile()
        }
      }
    },
    value: function () {
      this.buffer = this.value
    }
  }
}
</script>
